// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../ms/msAdmin/client/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../ms/msAdmin/client/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 思维模式列表：按钮图标与标题样式（与浏览器预览一致） */
.comps-ai-thinking-modes-list .ant-btn-icon {
  vertical-align: top;
}

.comps-ai-thinking-modes-list .ant-list-item-meta-title {
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./../../../sharedComponents/comps/CompsAi.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* 思维模式列表：按钮图标与标题样式（与浏览器预览一致） */\n.comps-ai-thinking-modes-list .ant-btn-icon {\n  vertical-align: top;\n}\n\n.comps-ai-thinking-modes-list .ant-list-item-meta-title {\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
